<template>
  <div class="dsf-control ds-teas-unite-nav-menu-setting mobile">
    <header v-if="scriptLoaded">
      <div class="title">
        <span>我的应用</span>
        <span>拖动可调整应用位置与排序</span>
      </div>
      <draggable ref="menus" v-model="selectMenus" class="group-content" v-bind="options">
        <template v-for="menu in selectMenus">
          <div :key="menu._id" class="menu-item" :data-id="menu._id">
            <div class="menu-item-box">
              <van-image :src="menu.picture | imgFormat">
                <template v-slot:error>
                  <i
                    class="iconfont"
                    :class="[menu.icon]"
                    :style="{ color: menu.color }"
                  />
                </template>
              </van-image>
              <div class="menu-item-name ds-multi-ellipsis-1">
                {{ menu.name }}
              </div>
              <i
                class="menu-item-bt iconfont icon-shanchu1"
                @click.stop="remove(menu)"
              ></i>
            </div>
          </div>
        </template>
      </draggable>
    </header>
    <van-divider>点击下方按钮，可添加菜单到我的应用</van-divider>
    <main>
      <div v-if="!menuList.length" class="no-data">暂时还没有数据~</div>
      <template v-for="group1 in menuList">
        <div
          v-if="group1.children && group1.children.length > 0"
          :key="group1._id"
          class="group"
        >
          <div class="group-title">
            <span>{{ group1.name }}</span>
          </div>
          <div class="group-content">
            <template v-for="group2 in group1.children">
              <div :key="group2._id" v-show="checkList.indexOf(group2._id) === -1" class="menu-item">
                <div class="menu-item-box" @click="selectChange(group2)">
                  <van-image :src="group2.picture | imgFormat">
                    <template v-slot:error>
                      <i
                        class="iconfont"
                        :class="[group2.icon]"
                        :style="{ color: group2.color }"
                      />
                    </template>
                  </van-image>
                  <div class="menu-item-name ds-multi-ellipsis-1">
                    {{ group2.name }}
                  </div>
                </div>
              </div>
              <template v-for="menu in group2.children">
                <div :key="menu._id" v-show="checkList.indexOf(menu._id) === -1" class="menu-item">
                  <div class="menu-item-box" @click="selectChange(menu)">
                    <van-image :src="menu.picture | imgFormat">
                      <template v-slot:error>
                        <i
                          class="iconfont"
                          :class="[menu.icon]"
                          :style="{ color: menu.color }"
                        />
                      </template>
                    </van-image>
                    <div class="menu-item-name ds-multi-ellipsis-1">
                      {{ menu.name }}
                    </div>
                  </div>
                </div>
              </template>
            </template>
          </div>
        </div>
      </template>
    </main>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfMobileTeasUniteNavMenuSetting",
  mixins: [$mixins.control],
  ctrlCaption: "菜单定制",
  data() {
    return {
      scriptLoaded: false,
      options: {
        animation: 300,
        delay: 300,
        forceFallback: true,
        draggable: ".menu-item",
        ghostClass: "ghost",
        chosenClass: "active",
      },
      menuList: [],
      checkList: [],
      selectMenus: [],
    };
  },
  created() {
    if (!this.isDesign) {
      this.loadScript(this.postData);
      this.init();
    } else {
      this.$dispatch("design-height-change", "100%");
    }
  },
  methods: {
    loadScript(callback) {
      if (window.vuedraggable) {
        this.scriptLoaded = true;
        callback?.();
      } else {
        this.$http
          .importFiles([
            dsf.url.getWebPath("$/js/libs/vuedraggable/Sortable-1.13.0.js"),
            dsf.url.getWebPath("$/js/libs/vuedraggable/vuedraggable.umd.js"),
          ])
          .then(() => {
            this.scriptLoaded = true;
            callback?.();
          })
          .catch((err) => {
            console.error(err);
            dsf.layer.message("加载fabric文件报错", false);
          });
      }
    },
    init() {
      let loading = dsf.layer.loading();
      this.$http.get("/menu/mobile/custommenu/getAppCustom", {
        code: 'stuManager',
        roleSerialNum: 'MC101'
      }).done(({ success, data, message }) => {
        if (success) {
          this.checkList = data.map(d => {
            d._id = d.id;
            return d.id;
          });
          this.selectMenus = data;
        } else {
          dsf.layer.message(message, false);
        }
      }).error((err) => {
        dsf.error(err);
        dsf.layer.message(err.message || "请求异常", false);
      }).always(() => {
        dsf.layer.closeLoading(loading);
      });
    },
    postData() {
      let loading = dsf.layer.loading();
      this.$http
        .get("/menu/mobile/custommenu/getAppTree")
        .done(({ success, data, message }) => {
          if (success) {
            this.menuList = data;
          } else {
            dsf.layer.message(message, false);
          }
        })
        .error((err) => {
          dsf.error(err);
          dsf.layer.message(err.message || "请求异常", false);
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },
    selectChange(item) {
      let e = this.checkList.indexOf(item._id) === -1;
      if (e) {
        this.checkList.push(item._id);
        this.selectMenus.push(item);
      } else {
        this.remove(item);
      }
    },
    remove(item) {
      let index = this.checkList.indexOf(item._id);
      this.checkList.splice(index, 1);
      index = this.selectMenus.findIndex((it) => item._id === it.id);
      this.selectMenus.splice(index, 1);
    },
    sortData() {
      return this.selectMenus.map((it, i) => {
        return {
          menuId: it._id,
          ds_order: i
        }
      });
    },
    submit(next) {
      let loading = dsf.layer.loading();
      this.$http
        .post("/menu/mobile/custommenu/saveMobCustomMenu", {
          data: JSON.stringify(this.sortData()),
        })
        .done(({ success, data, message }) => {
          if (success) {
            dsf.layer.message("保存成功", true);
            next && next();
          } else {
            dsf.layer.message(message, false);
          }
        })
        .error((err) => {
          dsf.error(err);
          dsf.layer.message(err.message || "请求异常", false);
        })
        .finally(() => {
          dsf.layer.closeLoading(loading);
        });
    },
  },
});
</script>
